export default {
    processing: "Obrađuje se",
    packing: "Pakuje se",
    confirmed: "Potvrđeno",
    transit: "U tranzitu",
    shipped: "Isporučeno",
    cancel: "Otkazano"
};
